import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import SettingsIcon from '@mui/icons-material/Settings';
import {
    Box,
    Button,
    Table, TableBody, TableCell, TableContainer, TableHead,
    TablePagination,
    TableRow,
    TextField,
    useTheme
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'rsuite';
import 'rsuite/DateRangePicker/styles/index.css';
import Header from '../../components/Header';
import { useCookiesLogin } from '../../config/cookies';
import { HOST_SINGED } from '../../config/hosts';
import { tokens } from '../../theme';

// Exemplo de dados do banco
const rows = [
    { id: 1, userId: 'a1b2c3d4', document: '12345678901', createdAt: dayjs().subtract(1, 'day').toISOString() },
    { id: 2, userId: 'e5f6g7h8', document: '98765432109', createdAt: dayjs().subtract(3, 'days').toISOString() },
    { id: 3, userId: 'i9j0k1l2', document: '11122233344', createdAt: dayjs().subtract(1, 'week').toISOString() },
    { id: 4, userId: 'm3n4o5p6', document: '55566677788', createdAt: dayjs().subtract(2, 'weeks').toISOString() },
    { id: 5, userId: 'n7o8p9q0', document: '44455566677', createdAt: dayjs().subtract(1, 'month').toISOString() },
    { id: 6, userId: 'r1s2t3u4', document: '99988877766', createdAt: dayjs().subtract(30, 'days').toISOString() },
    { id: 7, userId: 'v5w6x7y8', document: '12312312312', createdAt: '2024-05-08T13:45:10.000Z' },
    { id: 8, userId: 'z1a2b3c4', document: '32132132132', createdAt: '2024-03-12T09:20:15.000Z' },
    { id: 9, userId: 'd5e6f7g8', document: '98798798798', createdAt: '2024-01-22T16:30:25.000Z' },
];

const ConsultList = () => {
    const [filteredRows, setFilteredRows] = useState(rows);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [dateRange, setDateRange] = useState([null, null]);
    const [documentFilter, setDocumentFilter] = useState('');
    const [showDateRangePicker, setShowDateRangePicker] = useState(false);
    const [showDocumentFilter, setShowDocumentFilter] = useState(false);

    const [consults, setConsults] = useState([]);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { cookies } = useCookiesLogin();

    const { bussines_id  } = cookies.BRAUM_TOKEN;

    useEffect(() => {
        console.info("Atualizando filtro datas")
    }, [dateRange])

    useEffect(() => {
            fetch(`${HOST_SINGED}/reduto/consult/business/${bussines_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                if (res.status === 200) {
                    return res.json();
                }
            })
            .then((data) => {
                console.log(data, "data")
                setConsults(data.consults)
                setFilteredRows(data.consults)
            });
    }, []);
    const handleQuickSelect = (days) => {
        const today = dayjs();
        setDateRange([today.subtract(days, 'day'), today]);
        setShowDateRangePicker(false);
        filterByDateAndDocument();
    };

    const handleShowDateRangePicker = () => {
        setShowDateRangePicker(!showDateRangePicker);
    };

    const handleShowDocumentFilter = () => {
        setShowDocumentFilter(!showDocumentFilter);
    };

    const filterByDateAndDocument = () => {
        let filtered = rows;

        if (dateRange[0] && dateRange[1]) {
            const startDate = dayjs(dateRange[0]);
            const endDate = dayjs(dateRange[1]);
            filtered = filtered.filter(row => {
                const rowDate = dayjs(row.createdAt);
                return rowDate.isAfter(startDate) && rowDate.isBefore(endDate);
            });
        }

        if (documentFilter) {
            filtered = filtered.filter(row => row.document.includes(documentFilter));
        }

        setFilteredRows(filtered);
    };

    const clearFilters = () => {
        setDateRange([null, null]);
        setDocumentFilter('');
        setFilteredRows(rows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Box p={10} m={2}>
            
            

            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Header
                    title={`Todas consultas`}
                    subtitle="Visualize todas as consultas realizadas."
                />
                
                <Box sx={{ display: 'flex', gap: 2, marginBottom: 2 }}>
                    
                    <Button onClick={() => handleQuickSelect(1)} style={{ color: "#c5c5c5" }}>
                        <CalendarTodayIcon sx={{ color: colors.greenAccent[400], marginRight: 1 }} />
                        1 dia
                    </Button>
                    <Button onClick={() => handleQuickSelect(7)} style={{ color: "#c5c5c5" }}>
                        <CalendarTodayIcon sx={{ color: colors.greenAccent[400], marginRight: 1 }} />
                        7 dias
                    </Button>
                    <Button onClick={() => handleQuickSelect(30)} style={{ color: "#c5c5c5" }}>
                        <CalendarTodayIcon sx={{ color: colors.greenAccent[400], marginRight: 1 }} />
                        1 Mês
                    </Button>
                    <Button onClick={handleShowDateRangePicker} style={{ color: "#c5c5c5" }}>
                        <SettingsIcon sx={{ color: colors.greenAccent[400], marginRight: 1 }} />
                        Datas
                    </Button>
                    <Button onClick={handleShowDocumentFilter} style={{ color: "#c5c5c5" }}>
                        <FindInPageIcon sx={{ color: colors.greenAccent[400], marginRight: 1 }} />
                        CPF / CNPJ
                    </Button>
                </Box>

                <Box sx={{ display: 'flex', gap: 2, marginBottom: 2 }}>
                    {
                        showDocumentFilter && <TextField
                            label="CPF/CNPJ"
                            variant="outlined"
                            value={documentFilter}
                            onChange={(e) => {
                                setDocumentFilter(e.target.value);
                                filterByDateAndDocument(); // Atualiza a filtragem imediatamente ao digitar
                            }}
                            style={{ marginBottom: '10px', marginRight: '10px' }}
                        />
                    }
                </Box>
                
                
                {showDateRangePicker && (
                    <Box mt={2}>
                        <DateRangePicker
                            placeholder="Selecione a data"
                            onChange={(range) => {
                                setDateRange(range);
                                filterByDateAndDocument(); // Chama a filtragem diretamente
                            }}
                        />
                    </Box>
                )}

                <Button onClick={clearFilters} variant="contained">Limpar Filtros</Button>
            </LocalizationProvider>

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>User ID</TableCell>
                            <TableCell>Documento</TableCell>
                            <TableCell>Data de Criação</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                            <TableRow key={row.id}>
                                <TableCell>{row.id}</TableCell>
                                <TableCell>{row.user_id}</TableCell>
                                <TableCell>{row.document}</TableCell>
                                <TableCell>{dayjs(row.created_at).format('YYYY-MM-DD HH:mm')}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <TablePagination
                component="div"
                count={filteredRows.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Box>
    );
};

export default ConsultList;
